import { useGenericPopover } from '../generic-popover';
import {
  DeleteFilePopover,
  DeleteFilePopoverProps,
} from './delete-file-popover';

export const useDeleteFilePopover = ({
  title,
  onClose,
  onDelete,
  ...restProps
}: Partial<DeleteFilePopoverProps>) => {
  const { onClose: onClosePopover, trigger, popoverRef } = useGenericPopover();

  const deleteFilePopover = (
    <DeleteFilePopover
      {...restProps}
      trigger={trigger}
      popoverRef={popoverRef}
      title={title}
      onDelete={onDelete}
      onClose={onClosePopover}
    />
  );

  return {
    deleteFilePopover,
    trigger,
  };
};
